var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M832 0a192 192 0 0 1 192 192v640a192 192 0 0 1-192 192H192a192 192 0 0 1-192-192v-112.576l56.256 56.256c20.544 20.544 45.12 35.2 71.744 44.608V832a64 64 0 0 0 64 64h640c35.392 0 64-28.608 64-64V192a64 64 0 0 0-64-64H192C156.672 128 128 156.672 128 192v11.648c-26.56 9.408-51.136 24-71.744 44.544L0 304.448V192a192 192 0 0 1 192-192h640zM216.512 324.8A64.042667 64.042667 0 0 1 256 383.936V448h192a64 64 0 0 1 64 64c0 35.392-28.608 64-64 64h-192v63.936c0 25.856-15.616 49.28-39.488 59.136a64.213333 64.213333 0 0 1-69.76-13.888l-128-128A63.829333 63.829333 0 0 1 0 511.936c0-16.384 6.272-32.768 18.752-45.248l128-128a64.106667 64.106667 0 0 1 69.76-13.888z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.bbbad23d48291060e0761dd20d5db21c.svg";
export { ForwardRef as ReactComponent };